import { Link } from "@tanstack/react-router";
import { m } from "@/paraglide/messages";
import { TIMER_PRESET_LIST } from "../lib/presets";

const linkClass =
  "pct-panel flex items-center gap-2.5 rounded-xl px-4 py-3 text-sm font-medium transition-colors hover:border-primary/50 hover:bg-primary/[0.08]";

/**
 * Links to every preset timer (+ the hub and stopwatch). Keeps the timer
 * cluster interlinked for users and crawlers.
 *
 * `currentSlug` = a preset slug on preset pages, "stopwatch" on the stopwatch
 * page, or undefined on the hub.
 */
export function PresetGrid({ currentSlug }: { currentSlug?: string }) {
  const others = TIMER_PRESET_LIST.filter((p) => p.slug !== currentSlug);
  return (
    <section className="mt-12">
      <h2 className="mb-4 font-display text-xl font-bold tracking-tight">
        {m.timer_more_title()}
      </h2>
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4">
        {currentSlug !== undefined && (
          <Link to="/timer" className={linkClass}>
            <span aria-hidden>⏱️</span>
            <span>{m.timer_nav_timer()}</span>
          </Link>
        )}
        {currentSlug !== "stopwatch" && (
          <Link to="/timer/stopwatch" className={linkClass}>
            <span aria-hidden>⏲️</span>
            <span>{m.timer_nav_stopwatch()}</span>
          </Link>
        )}
        {others.map((p) => (
          <Link
            key={p.slug}
            to="/timer/$preset"
            params={{ preset: p.slug }}
            className={linkClass}
          >
            <span aria-hidden>⏳</span>
            <span>{p.navName()}</span>
          </Link>
        ))}
      </div>
    </section>
  );
}
